import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import {
  checkExistingActualTemplate,
  createNotificationTemplate,
  editNotificationTemplateById,
  loadTemplateHelperData,
} from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getFirstFormError, getResponseError, setFormError } from '../../../utils/utils';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import MultipleSelectInput from '../../../components/fields/SelectInput/MultipleSelectInput';
import {
  INTERNAL_APPLICATION_STATUS_LIST,
  NOTIFICATION_TEMPLATE_STATUS,
  NOTIFICATION_TEMPLATE_STATUS_LIST,
  PROCEDURE_TYPE_LIST,
  REGISTRIES_STATUS_LIST,
  REGISTRIES_TYPE_LIST,
} from '../../../configs';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import NotificationTemplateRegistryDTO from '../../../dto/NotificationTemplateRegistryDTO';
import Switches from '../../../components/fields/Switches/Switches';
import WysiwygInput from '../../../components/fields/TextInput/WysiwygInput';
import { getReferenceInformationData } from '../reducer';
import NotificationTemplateHelper from './NotificationTemplateHelper';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import { loadDocumentTypes } from '../../Authorized/actions';
import SelectInputWithHelper from '../../../components/fields/SelectInput/SelectInputWithHelper';
import { showGlobalConfirm } from '../../System/actions';

export default function NotificationTemplateForm(props) {
  const {
    close = () => {},
    loadData = () => {},
    current = {},
    isEdit = false,
  } = props;
  const dispatch = useDispatch();
  const [showHelper, setShowHelper] = useState(false);
  const {
    loadingTemplateHelperData,
    templateHelperData,
  } = useSelector(getReferenceInformationData);
  const {
    control,
    getValues,
    formState: { errors },
    setError,
    setFocus,
  } = useForm({
    mode: 'onChange',
    defaultValues: isEdit ? { is_statement: false, ...current } : { is_statement: false, status: NOTIFICATION_TEMPLATE_STATUS.ACTIVE },
  });

  const handleSave = () => {
    const error = getFirstFormError(errors);
    if (error) {
      errorNotification('Сохранение формы', 'Ошибка заполнения формы');
      const { ref } = error;
      if (ref && ref.name) {
        setFocus(ref.name);
      }
      return null;
    }
    const values = getValues();
    const data = { ...values, id: current.id };
    if (isEdit && current.id && current.status === NOTIFICATION_TEMPLATE_STATUS.ACTIVE) {
      return saveProcess(data);
    }
    dispatch(checkExistingActualTemplate(values.type)).then(a => {
      if (a.exists) {
        dispatch(showGlobalConfirm({
          confirmTitle: 'Сохранение формы',
          confirmMessage: (
            <div className="validation-block">
              Найден другой активный шаблон с данным типом.
            </div>
          ),
          confirmButtonText: 'Архивировать другой шаблон',
          confirmCancelButtonText: 'Отмена сохранения',
          confirmClassName: 'remove-preset',
        })).then(() => {
          saveProcess(data);
        }).catch(() => {});
      } else {
        saveProcess(data);
      }
    })
      .catch(response => errorNotification('Сохранение формы', getResponseError(response)));
  };

  const saveProcess = data => {
    const action = isEdit ? editNotificationTemplateById : createNotificationTemplate;
    dispatch(action(data))
      .then(() => {
        loadData();
        close();
        successNotification('Сохранение формы', 'Форма сохранена');
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение формы', getResponseError({ error: response && response.message ? response.message : '' }));
      });
  };

  const handleShowHelper = () => {
    dispatch(loadTemplateHelperData())
      .then(() => setShowHelper(true))
      .catch(response => errorNotification('Загрузка справочника', getResponseError(response)));
  };

  const DTO = new NotificationTemplateRegistryDTO();
  const attributes = DTO.getAttributesByName();

  return (
    <Dialog
      className="notification-template-form"
      onClose={close}
      open
      disableESC
    >
      <DialogTitle header={isEdit ? 'Редактирование бланка уведомления' : 'Создание бланка уведомления'} title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="application-denied-content">
        <TimerLoader loading={loadingTemplateHelperData} />
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.name}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={MultipleSelectInput}
            dtoObject={attributes.procedures}
            withLabel
            variant="material"
            options={PROCEDURE_TYPE_LIST}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.application_status}
            options={INTERNAL_APPLICATION_STATUS_LIST}
            withLabel
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={SelectInputWithHelper}
            dtoObject={attributes.type}
            variant="material"
            withLabel
            usePortal
            loadAction={loadDocumentTypes}
            optionFormatter={item => ({ value: item.value, name: item.label })}
            filterName="full_name"
            disabled={isEdit}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={MultipleSelectInput}
            dtoObject={attributes.registries}
            options={REGISTRIES_TYPE_LIST}
            withLabel
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.registry_status}
            options={REGISTRIES_STATUS_LIST}
            withLabel
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            options={NOTIFICATION_TEMPLATE_STATUS_LIST}
            withLabel
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={Switches}
            dtoObject={attributes.is_statement}
            withLabel
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={WysiwygInput}
            textarea
            dtoObject={attributes.message}
            placeholder=""
            withLabel
            variant="material"
            handleShowHelper={handleShowHelper}
          />
        </Row>
        {showHelper ? <NotificationTemplateHelper templateHelperData={templateHelperData} close={() => setShowHelper(false)} /> : null}
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={close}>Отменить</Button>
          <Button className="hff-clear-show" type="submit" onClick={handleSave}>Сохранить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
